const FourOhFourPage = () => {
  return `<section class="four-oh-four first-from-top">
          <div class="fof-bot"><img src="./images/404.svg" alt="404 bot" /></div>
          <div class="container">
            <h5>Welp...</h5>
            <h2>Something went wrong</h2>
            <p>There was an error in your request. We're not sure what happened.</p>
            <h6>Try something else or go to the <a href="#/dashboard">Dashboard</a></h6>
            </div>
        </section>
        `;
};

export default FourOhFourPage;
